/* eslint-disable react/no-unescaped-entities */
import MailTo from "components/errors/MailTo";
import PolicyPage from "components/policies/PolicyPage";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import parse from "date-fns/parse";
import { useIntl } from "react-intl";

function AntiScrapingTerms() {
  const intl = useIntl();
  if (!intl.locale.startsWith("pt")) {
    return (
      <>
        <FundamenteiMetadata title="Anti-Scraping Terms and Conditions | Fundamentei" />
        <PolicyPage
          title="Anti-Scraping Terms and Conditions"
          lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}
        >
          <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
            <p>
              Fundamentei Serviços de Informação LTDA (“We”), CNPJ 35.804.692/0001-05, establishes guidelines and rules
              for the use of any content provided by us and prohibits unauthorized scraping activities. By accessing or
              using any content provided by us, you agree to these Terms. We recommend careful reading.
            </p>
            <ul>
              <li className="list-none">
                <strong>1. Definitions</strong>
              </li>
              <li>
                <p>
                  1.1. Scraping refers to the practice of automatically collecting, through tools and other mechanisms,
                  information from a website or online resource, commonly without the permission of the website owner.
                </p>
              </li>
              <li>
                <p>
                  1.2. User: You, the person or entity that accesses, uses, or attempts to access or use any content
                  provided by us.
                </p>
              </li>
              <li className="list-none">
                <strong>2. Prohibition of Unauthorized Scraping</strong>
              </li>
              <li>
                <p>
                  2.1. You agree not to engage in unauthorized scraping of any content provided by us. This includes
                  collecting, copying, distributing, displaying, publishing, or any other form of obtaining information
                  from our resources in an automated manner without our express authorization.
                </p>
              </li>
              <li className="list-none">
                <strong>3. Authorized Use</strong>
              </li>
              <li>
                <p>
                  3.1. Any authorized use of the content provided by us will be carried out in an express and
                  unequivocal manner. Authorized use will be subject to specific terms and conditions that will be
                  outlined in a separate document.
                </p>
              </li>
              <li className="list-none">
                <strong>4. Detection and Consequences</strong>
              </li>
              <li>
                <p>
                  4.1. Considering that we take an absolute and total stance against scraping practices, there will be
                  no tolerance or conditionality upon identification of this practice by the user, and we will not
                  hesitate to take appropriate measures within our reach.
                </p>
              </li>
              <li>
                <p>
                  4.2. We reserve the right to monitor, detect, and respond to unauthorized scraping activities. This
                  may include blocking IP addresses, canceling subscriptions, blocking accounts, and other measures to
                  prevent the continuation of these activities.
                </p>
              </li>
              <li>
                <p>
                  4.3. Violation of these Terms will subject you to legal actions, including but not limited to,
                  lawsuits to enforce our rights and seek compensation for damages, both civil and criminal.
                </p>
              </li>
              <li>
                <p>
                  4.4. The user acknowledges that, upon identifying scraping practices, we may share access data (IP,
                  user agent, location, among others) with third parties if necessary for the analysis of the practice.
                </p>
              </li>
              <li className="list-none">
                <strong>5. Reporting and Notification of Violations</strong>
              </li>
              <li>
                <p>
                  5.1. If you believe unauthorized scraping of our content is occurring, please contact us at the
                  following email address: <MailTo address="contato@fundamentei.com" />. We will take recommended
                  measures to investigate and rectify any detected violation.
                </p>
              </li>
              <li className="list-none">
                <strong>6. Changes to the Terms</strong>
              </li>
              <li>
                <p>
                  6.1. We reserve the right to change these Terms at any time. Any changes will be published on our
                  website or through other forms of communication. Continued use of our content after changes are
                  implemented will signify your acceptance of those changes.
                </p>
              </li>
              <li className="list-none">
                <strong>7. Conclusion</strong>
              </li>
              <li>
                <p>
                  7.1. These Terms constitute the entire agreement between you and us regarding the use of our content
                  and the prohibition of unauthorized scraping. They replace all prior or contemporaneous
                  communications, written or oral.
                </p>
              </li>
              <li>
                <p>
                  7.2. These Terms are governed by the laws of Brazil, respecting all other laws and international
                  treaties to which Brazil is a party, and any disputes arising or related to them will be submitted to
                  the exclusive jurisdiction of the courts of that jurisdiction.
                </p>
              </li>
              <li>
                <p>
                  By accepting these terms, you acknowledge that you understand and agree to adhere to the rules and
                  guidelines regarding the use of our content and the prohibition of unauthorized scraping.
                  Non-compliance with these terms may result in legal consequences.
                </p>
              </li>
            </ul>
          </div>
        </PolicyPage>
      </>
    );
  }
  return (
    <>
      <FundamenteiMetadata title="Termos e Condições Anti-Scraping | Fundamentei" />
      <PolicyPage
        title="Termos e Condições Anti-Scraping"
        lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}
      >
        <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
          <p>
            A Fundamentei Serviços de Informação LTDA (“Nós”), CNPJ 35.804.692/0001-05, estabelece as diretrizes e
            regras para o uso de qualquer conteúdo disponibilizado por nós e proíbe atividades de scraping não
            autorizadas. Ao acessar ou utilizar qualquer conteúdo fornecido por nós, você concorda com estes Termos.
            Orientamos a leitura com atenção.
          </p>
          <ul>
            <li className="list-none">
              <strong>1. Definições</strong>
            </li>
            <li>
              <p>
                1.1. Scraping se refere à prática de coletar automaticamente, por meio de ferramentas e outros
                mecanismos, informações de um site ou recurso online, comumente sem a permissão do proprietário do site.
              </p>
            </li>
            <li>
              <p>
                1.2. Usuário: Você, a pessoa ou entidade que acessa, utiliza, ou tenta acessar ou utilizar qualquer
                conteúdo fornecido por nós.
              </p>
            </li>
            <li className="list-none">
              <strong>2. Proibição de Scraping Não Autorizado</strong>
            </li>
            <li>
              <p>
                2.1. Você concorda em não se envolver em scraping não autorizado de qualquer conteúdo disponibilizado
                por nós. Isso inclui a coleta, cópia, distribuição, exibição, publicação, ou qualquer outra forma de
                obtenção de informações de nossos recursos de forma automatizada sem nossa autorização expressa.
              </p>
            </li>
            <li className="list-none">
              <strong>3. Uso Autorizado</strong>
            </li>
            <li>
              <p>
                3.1. Qualquer uso autorizado do conteúdo fornecido por Nós será realizado de forma expressa e
                inequívoca. O uso autorizado estará sujeito a termos e condições específicas que serão previstos em
                documento próprio.
              </p>
            </li>
            <li className="list-none">
              <strong>4. Detecção e Consequências</strong>
            </li>
            <li>
              <p>
                4.1. Considerando que nós adotamos conduta absoluta e totalmente contrária à prática de scraping, não
                haverá qualquer tolerância ou condicional quando da identificação desta prática pelo usuário, de modo
                que não hesitaremos em tomar as medidas cabíveis ao nosso alcance.
              </p>
            </li>
            <li>
              <p>
                4.2. Reservamo-nos o direito de monitorar, detectar e responder a atividades de scraping não autorizado.
                Isso pode incluir o bloqueio de endereços IP, cancelamento de assinatura, bloqueio de contas e entre
                outras medidas para prevenir a continuação dessas atividades.
              </p>
            </li>
            <li>
              <p>
                4.3. A violação destes Termos sujeitará você a medidas legais, incluindo, mas não se limitando a, ações
                judiciais para fazer valer nossos direitos e buscar reparação por danos, tanto em âmbito civil quanto
                criminal.
              </p>
            </li>
            <li>
              <p>
                4.4. O usuário se declara ciente que, ao identificar a prática de scraping, poderemos compartilhar os
                dados de acesso (IP, agente de usuário, localização e entre outros) do usuário com terceiros caso assim
                seja necessário para fins de análise da prática.
              </p>
            </li>
            <li className="list-none">
              <strong>5. Denúncias e Notificação de Violação</strong>
            </li>
            <li>
              <p>
                5.1. Se você acredita que o scraping não autorizado de nosso conteúdo está ocorrendo, entre em contato
                conosco por meio do seguinte endereço de e-mail: <MailTo address="contato@fundamentei.com" />. Tomaremos
                as medidas recomendadas para investigar e corrigir qualquer violação detectada.
              </p>
            </li>
            <li className="list-none">
              <strong>6. Alterações nos Termos</strong>
            </li>
            <li>
              <p>
                6.1. Reservamo-nos o direito de alterar estes Termos a qualquer momento. Quaisquer alterações serão
                publicadas em nosso site ou por meio de outras formas de comunicação. O uso contínuo de nosso conteúdo
                após a implementação de alterações significará sua aceitação dessas alterações.
              </p>
            </li>
            <li className="list-none">
              <strong>7. Conclusão</strong>
            </li>
            <li>
              <p>
                7.1. Este Termo constitui o acordo integral entre você e Nós no que diz respeito ao uso de nosso
                conteúdo e a proibição de scraping não autorizado. Eles substituem todas as comunicações anteriores ou
                contemporâneas, escritas ou orais.
              </p>
            </li>
            <li>
              <p>
                7.2. Este Termo é regido pelas leis do Brasil, respeitadas todas as demais legislações e tratados
                internacionais dos quais o Brasil participa, e quaisquer disputas decorrentes ou relacionadas a eles
                serão submetidas à jurisdição exclusiva dos tribunais dessa jurisdição.
              </p>
            </li>
            <li>
              <p>
                Ao aceitar esses termos, você reconhece que entendeu e concorda em respeitar as regras e diretrizes
                relativas ao uso de nosso conteúdo e à proibição de scraping não autorizado. O não cumprimento destes
                termos pode resultar em consequências legais.
              </p>
            </li>
          </ul>
        </div>
      </PolicyPage>
    </>
  );
}

export default AntiScrapingTerms;
